import { createFileRoute } from "@tanstack/react-router";

import { pageTitle } from "@/i18n/title";
import { query } from "@/queries";
import { SupportInboxPage } from "@/supportChats/SupportInboxPage";

export const Route = createFileRoute("/_authed/support/")({
  head: () => pageTitle("Support"),
  // Warms the inbox on hover; the page shows its own wait and errors.
  loader: ({ context: { queryClient } }) => {
    void queryClient.query(query.support.threads()).catch(() => undefined);
  },
  component: SupportInboxPage,
});
